import { Datagrid, DateField, EditButton, List, TextField } from "react-admin";

export function SeoList() {
  return (
    <List>
      <Datagrid>
        <TextField source="slug" />
        <TextField source="title" />
        <DateField source="createdDate" />
        <DateField source="updatedDate" />
        <EditButton />
      </Datagrid>
    </List>
  );
}
